import { render, staticRenderFns } from "./RecipeEdit.vue?vue&type=template&id=5e472396&"
import script from "./RecipeEdit.vue?vue&type=script&lang=js&"
export * from "./RecipeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports